import { render, staticRenderFns } from "./SuccessMobilePassword.vue?vue&type=template&id=6ef6eaa7&scoped=true&"
import script from "./SuccessMobilePassword.vue?vue&type=script&lang=js&"
export * from "./SuccessMobilePassword.vue?vue&type=script&lang=js&"
import style0 from "./SuccessMobilePassword.vue?vue&type=style&index=0&id=6ef6eaa7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6eaa7",
  null
  
)

export default component.exports